var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeroSection'),_c('BadgeSection'),_c('ProcessSection'),_c('AdvantageSection'),_c('ProductSection'),_c('ServiceSection'),_c('AboutSection'),_c('ContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }